<template>
    <div id="creative-exp-package">
        <div>
            <div class="header">
                <div>
                    <h1 id="landing-logo" class="logo"><a href="/"><img src="img/landing_v2/ailearn-logo.svg" @click="sendGtag('logo')"  alt="로고" /> <span>에이아이런</span></a></h1>
                </div>
            </div>
            <section class="section-wrap section11">
                <section class="section-inner">
                    <h3>선생님과 학생들에게<br>
                        가장 인기있는 챗봇을 추천합니다!</h3>
                </section>
            </section>
            <!-- // Start : 컨텐츠 -->
            <section class="section-wrap section05">
                <section class="section-inner">
                    <div class="section-item">
                        <h4>4차시 수업 구성</h4>
                        <div>
                            <p>2차시 수업 구성</p>
                            <ul>
                                <li class="item03">
                                    <img src="img/section05_img03.png" />
                                    <span>직업소개 챗봇 만들기</span>
                                    학생이 관심있는 직업에<br>
                                    대해 안내해주는 챗봇
                                    <a id="bot16" href="https://frogue.danbee.ai/?chatbot_id=f2e6a31f-77ef-45fb-a290-fe60bd9aa66d" @click="sendGtag('직업소개봇')" target="_blank"><img src="img/icon_ex.svg"/> 예시보기</a>
                                </li>
                                <li class="item07">
                                    <img src="img/promotion/section05_img07.png" />
                                    <span>캐릭터 챗봇 만들기</span>
                                    좋아하는 캐릭터에 관해<br>
                                    알려주는 챗봇
                                    <a id="bot15-popup" href="https://frogue.danbee.ai/?chatbot_id=2feb939a-6329-4544-8438-91eb95b6a663" @click="sendGtag('캐릭터봇')" target="_blank"><img src="img/icon_ex.svg"> 예시보기</a>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <p>2차시 수업 구성</p>
                            <ul>
                                <li class="item04">
                                    <img src="img/section05_img04.png" />
                                    <span>퀴즈 챗봇 만들기</span>
                                    학생 관심분야의 퀴즈를 내고<br>
                                    채점하여 점수를 알려주는 챗봇
                                    <a id="bot23" href="https://frogue.danbee.ai/?chatbot_id=1f249219-da73-4e1c-ac4d-22d759790eb1" @click="sendGtag('퀴즈봇')" target="_blank"><img src="img/icon_ex.svg"/> 예시보기</a>
                                </li>
                                <li class="item08">
                                    <img src="img/promotion/section05_img08.png" />
                                    <span>여행지 추첫 챗봇 만들기</span>
                                    산, 바다, 도시 중 갈만한 여행지를<br>
                                    추천해주는 챗봇
                                    <a id="bot21-popup" href="https://frogue.danbee.ai/?chatbot_id=e3aec7eb-b123-402d-bd60-cc0fcab87e04" @click="sendGtag('여행지추천봇')" target="_blank"><img src="img/icon_ex.svg"> 예시보기</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </section>
            </section>
            <section id="section10" class="section-wrap section10">
                <section class="section-inner">
                    
                    <p class="caption">※ 학교 내부 결재에 필요한 견적서가 필요한 경우,<br>
                        이메일로 견적서를 요청하시면 견적서를 발행해 드립니다.</p>
                    <div class="section-item">
                        <div class="form-wrap">
                            <div class="form-inner">
                                <div class="form">
                                    <em>필수 입력 사항</em>
                                    <table>
                                        <tr>
                                            <th><span>신청기관명</span></th>
                                            <td class="pt-6">
                                                <input type="text" v-model="schoolName" placeholder="신청기관(학교)명을 입력해주세요." @click="sendGtag('schoolName')" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <th><span>신청인</span></th>
                                            <td>
                                                <input type="text" v-model="userName" placeholder="신청하시는 분의 성함을 입력해주세요." @click="sendGtag('userName')" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <th><span>연락처</span></th>
                                            <td>
                                                <input type="tel" v-model="phoneNumber" placeholder="휴대폰 번호를 입력해주세요." @click="sendGtag('phoneNumber')" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <th><span>이메일</span></th>
                                            <td>
                                                <input type="email" v-model="email" placeholder="이메일 주소를 입력해주세요." @click="sendGtag('email')" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <th><span>학급수</span></th>
                                            <td>
                                                <input type="number" v-model="classCnt" placeholder="수업할 학급 수를 입력해 주세요." @click="sendGtag('classCnt')" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <th><span>수업차시</span></th>
                                            <td>
                                                <input type="number" v-model="sisuCnt" placeholder="예상 수업 시간을 입력해주세요." @click="sendGtag('sisuCnt')" />
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button class="btn" @click="submit()"><img src="img/promotion/icon-file.png" /> 견적서 요청하기</button>
                </section>
            </section>
            <section class="section-wrap section12">
                <section class="section-inner">
                    <img src="img/promotion/section12_cha.png" />
                    <p class="caption">먼저 어떻게 챗봇을 만들 수 있는지 알고 싶으시다면<br>
                        무료체험 신청을 해 보세요!</p>
                    <a href="https://ailearn.co.kr/#section10" class="btn" @click="sendGtag('무료체험 신청')"><img src="img/promotion/icon-teacher.png" /> 무료체험 신청하기</a>
                </section>
            </section>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "creative-exp-package",
        data() {
            return {
                schoolName: '',
                userName: '',
                phoneNumber: '',
                email: '',
                classCnt: 4,
                sisuCnt: 2, // n차시...(시수)
                btnDisabled: false,
            };
        },
        created: function() {
        },
        methods: {
            submit(){
                gtag('event', '견적서 요청', {
                    'event_category': 'click',
                    'event_label': '견적서 요청',
                    'value': '',
                });

                if(!this.btnDisabled) {
                    this.btnDisabled = true;
                } else {
                    return false;
                }
                if(this.schoolName === '') {
                    swal("필수 항목 미입력", "'신청기관명'을 입력해주세요.", "error" );
                    this.btnDisabled = false;
                    return false;
                }
                if(this.userName === '') {
                    swal("필수 항목 미입력", "'신청인'을 입력해주세요.", "error" );
                    this.btnDisabled = false;
                    return false;
                } else {
                    // let userNamePattern = /^[ㄱ-ㅎㅏ-ㅣ가-힣]{2,20}$/;
                    // if(!userNamePattern.test(this.userName)) {
                    //     alert('최소 2글자 이상의 한글 이름을 입력해주시기 바랍니다.');
                    //     this.btnDisabled = false;
                    //     return false;
                    // }
                }
                if(this.phoneNumber === '') {
                    swal("필수 항목 미입력", "'연락처'을 입력해주세요.", "error" );
                    this.btnDisabled = false;
                    return false;
                }
                if(this.email === '') {
                    swal("필수 항목 미입력", "'이메일'을 입력해주세요.", "error" );
                    this.btnDisabled = false;
                    return false;
                } else {
                    var emailPattern = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
                    if(!emailPattern.test(this.email)){
                        swal("이메일 형식 오류", "올바른 이메일 형식이 아닙니다.", "error" );
                        this.btnDisabled = false;
                        return false;
                    }
                }
                if(this.classCnt === null || this.classCnt === '') {
                    swal("필수 항목 미입력", "'학급수'를 입력해주세요.", "error" );
                    this.btnDisabled = false;
                    return false;
                }
                if(this.sisuCnt === null || this.sisuCnt === '') {
                    swal("필수 항목 미입력", "'수업차시'를 입력해주세요.", "error" );
                    this.btnDisabled = false;
                    return false;
                }

                let parameters = {
                    schoolName: this.schoolName,
                    userName: this.userName,
                    phoneNumber: this.phoneNumber,
                    email: this.email,
                    classCnt: this.classCnt,
                    sisuCnt: this.sisuCnt,
                };

                // console.log(parameters);

                // 운영 > (주)단비아이엔씨 > [삭제X] 아이런 랜딩 무료체험 접수 > 견적서요청(/creative_exp_package.html)

                swal("요청 성공", "견적서가 요청되었습니다.", "success" );

                let url = 'https:\/\/danbee.ai/chatflow/event/v2.0/10b92062-314a-4886-b64b-980fb0a3c228/46f87ab3-5f4f-432b-81e5-f3839e4719c7/message.do';
                axios({
                    method : 'POST',
                    url : url,
                    headers : {
                        'Content-Type' : 'application/json'
                    },
                    data : JSON.stringify({
                        chatbot_id: '10b92062-314a-4886-b64b-980fb0a3c228',
                        parameters: parameters,
                    })
                }).then((response) => {
                    // console.log('response : ');
                    // console.log(response);
                    // alert('상담신청이 접수되었습니다.');
                    this.resetParameters();

                    gtag('event', 'goal', {
                        'event_category': 'click',
                        'event_label': 'goal',
                        'value': '',
                    });
                }).catch((error) => {
                    swal("요청 실패", "오류가 발생했습니다. 관리자에게 문의바랍니다.", "error" );
                    this.btnDisabled = false;
                });
            },
            resetParameters() {
                this.btnDisabled = false;
                this.schoolName = '';
                this.userName = '';
                this.phoneNumber = '';
                this.email = '';
            },
            sendGtag(type) {
                let event_label = type || '';
                // console.log(type);
                switch (type) {
                    case 'schoolName':
                        event_label = '신청기관명';
                        break;
                    case 'userName':
                        event_label = '신청인';
                        break;
                    case 'phoneNumber':
                        event_label = '연락처';
                        break;
                    case 'email':
                        event_label = '이메일';
                        break;
                    case 'classCnt':
                        event_label = '학급수';
                        break;
                    case 'sisuCnt':
                        event_label = '수업차시';
                        break;
                }
                gtag('event', event_label, {
                    'event_category': 'click',
                    'event_label': event_label,
                    'value': '',
                });
            }
        },
        beforeDestroy() {
        },
        destroyed () {
        },
        watch: {
        },
        computed: {
        }
    }
</script>



// WEBPACK FOOTER //
// src/creative_exp_package.vue